import { useState, useEffect, useContext } from 'react';
import { AppContext } from 'commons-ui';
import { useLocation, useHistory } from 'react-router-dom';
import useService from '../../utils/useService';
import { hydrateFormData } from '../../utils/formDataParser';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const { requestUpdateConfig } = useService();
	const history = useHistory();
	const [data, setData] = useState({});
	const location = useLocation();

	useEffect(() => {
		const fetchData = async () => {
			try {
				setShowLoader(true);
				if (location.state?.configData) {
					setData(location.state.configData);
				}
			} catch (error) {
				showAlert(`Failed to get config: ${'Unknown error'}`, { type: 'error' });
			} finally {
				setShowLoader(false);
			}
		};

		fetchData();
	}, [location]);

	const handleFormSubmit = async (formData: any) => {
		try {
			setShowLoader(true);
			const hydratedData = hydrateFormData(formData);
			let result;

			// Handle single configuration based on device type
			if (location.state?.deviceType === 'IOS' && hydratedData.data.splashIOS) {
				result = await requestUpdateConfig({
					data: hydratedData.data.splashIOS,
					objectKey: 'splashIOS',
					desc: 'Updating splashIOS configuration value'
				});
			} else if (location.state?.deviceType === 'ANDROID' && hydratedData.data.splashAndroid) {
				result = await requestUpdateConfig({
					data: hydratedData.data.splashAndroid,
					objectKey: 'splashAndroid',
					desc: 'Updating splashAndroid configuration value'
				});
			}
			if (!result.data.success) {
				showAlert(`Failed to edit config: ${result.data.message || 'Unknown error'}`, { type: 'error' });
			}

			history.push('/gameAdmin/zkDashBoardUpdate/list');
			return result;
		} catch (error) {
			showAlert(`Failed to edit config: ${'Unknown error'}`, { type: 'error' });
			throw error;
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormCancel = () => {
		history.goBack();
		// Your cancel logic here
	};

	return {
		showLoader,
		setShowLoader,
		handleFormSubmit,
		handleFormCancel,
		data,
		setData
	};
};

export default useEdit;
